module.exports = __webpack_public_path__ + "img/icons.ab9a6af4.png";